import { render, staticRenderFns } from "./OrbitEditProjectModal.vue?vue&type=template&id=1f9d8a4f"
import script from "./OrbitEditProjectModal.vue?vue&type=script&lang=ts"
export * from "./OrbitEditProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitEditProjectModal.vue?vue&type=style&index=0&id=1f9d8a4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports